import { registerLocaleData } from '@angular/common';
import { provideHttpClient, withFetch } from '@angular/common/http';
import localeEsMx from '@angular/common/locales/es-MX';
import { ApplicationConfig, LOCALE_ID } from '@angular/core';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { getApp, initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAuth, initializeAuth, provideAuth } from '@angular/fire/auth';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getRemoteConfig, provideRemoteConfig } from '@angular/fire/remote-config';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withEnabledBlockingInitialNavigation } from '@angular/router';
import { browserLocalPersistence } from '@firebase/auth';
import player from 'lottie-web';
import { RECAPTCHA_V3_SITE_KEY } from 'ng-recaptcha';
import { NgxImageCompressService } from 'ngx-image-compress';
import { provideCacheableAnimationLoader, provideLottieOptions } from 'ngx-lottie';
import { MessageService } from 'primeng/api';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';
import { constants } from './constants';
import { FirebaseStorageService } from './services/firebase-storage/firebase-storage.service';
import { FirestoreService } from './services/firestore/firestore.service';

registerLocaleData(localeEsMx);

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: LOCALE_ID, useValue: constants.defaultLocale },
    provideAnimations(),
    provideRouter(appRoutes, withEnabledBlockingInitialNavigation()),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    provideRemoteConfig(() => getRemoteConfig()),
    provideFirebaseApp(() => initializeApp(environment.accountsServerFirebaseConfig, 'accountsServer')),
    provideFirestore(() => getFirestore(getApp('accountsServer'))),
    provideAnalytics(() => getAnalytics()),
    {
      provide: 'accountsServerAuth',
      useFactory: () => initializeAuth(getApp('accountsServer'), { persistence: browserLocalPersistence }),
    },
    {
      provide: 'appFirestore',
      useFactory: () => new FirestoreService(),
    },
    {
      provide: 'appFirebaseStorage',
      useFactory: () => new FirebaseStorageService(),
    },
    {
      provide: 'accountsServerFirestore',
      useFactory: () => new FirestoreService('accountsServer'),
    },
    provideHttpClient(withFetch()),
    MessageService,
    NgxImageCompressService,
    // TODO: Delete when use firestore native
    { provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },
    provideHttpClient(),
    provideLottieOptions({
      player: () => player,
    }),
    provideCacheableAnimationLoader(),
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: environment.recaptchaSiteKey,
    },
  ],
};
